import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {Message} from '../../value-object/message';
import {MessagesService} from '../../services/messages.service';
import {AsyncPipe} from '@angular/common';
import {DisplayMessageComponent} from '../display-message/display-message.component';
import {TranslateLoader} from '@ngx-translate/core';
import {localizationHttpLoaderFactory} from '../../translate/factory/translate-http-loader.factory';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-display-messages',
  imports: [
    AsyncPipe,
    DisplayMessageComponent
  ],
  providers: [
    {
      provide: TranslateLoader,
      useFactory: localizationHttpLoaderFactory,
      deps: [HttpClient]
    }
  ],
  templateUrl: './display-messages.component.html',
  styleUrl: './display-messages.component.scss'
})
export class DisplayMessagesComponent {
  public readonly messages: Observable<Message[]>;

  public constructor(
    private readonly messagesService: MessagesService
  ) {
    this.messages = this.messagesService.messages;
  }
}
